"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');
var _lodash = require('lodash');

var _conversation = require('shared/services/conversation');
var _dayRollover = require('shared/services/dayRollover');
var _time = require('shared/services/time');









var _blobject = require('shared/selectors/blobject');



var _conversation3 = require('shared/selectors/conversation');



var _user = require('shared/selectors/user');


var _scheduledMessages = require('shared/selectors/scheduledMessages');

/* The own props both apps pass (web StoreConversationBox, mobile MessagesBox). */
















const EMPTY_CHAT = { messageBatches: [[]] }
const MAX_TEN = { memoize: _toolkit.lruMemoize, memoizeOptions: { maxSize: 10 } }

const selectConversation = (state, { conversationKey }) =>
  _conversation3.selectConversationByKey.call(void 0, state, conversationKey)
const selectBlobject = (state, { blobjectKey }) =>
  _blobject.selectBlobjectByKey.call(void 0, state, blobjectKey)
const selectMessages = (state, { conversationKey }) =>
  _conversation3.selectMessagesByConversationKey.call(void 0, state, conversationKey)
const selectLastSeenTime = (state, { blobjectKey, anchorSeenTime }) =>
  _nullishCoalesce(anchorSeenTime, () => ( _blobject.selectMyBlobjectLastSeenTime.call(void 0, state, blobjectKey)))
const selectSubscribers = (state, { blobjectKey }) =>
  _blobject.selectBlobjectSubscribers.call(void 0, state, blobjectKey)
const selectConversationKey = (_state, { conversationKey }) => conversationKey
const selectBlobjectKey = (_state, { blobjectKey }) => blobjectKey
const selectHighlightedMessageKey = (_state, { highlightedMessageKey }) =>
  highlightedMessageKey
// The date dividers say "Today"/"Yesterday", so the batches depend on the
// current day as well as the store. A string, so the memo still hits all day.
const selectCurrentDay = () => _dayRollover.getCurrentDayKey.call(void 0, )
const selectChatType = (state, props) => _optionalChain([selectBlobject, 'call', _ => _(state, props), 'optionalAccess', _2 => _2.WrappedType])
const selectScheduledRows = (state, { conversationKey }) =>
  _scheduledMessages.selectScheduledMessages.call(void 0, state, conversationKey)

// The Scheduled bubbles that follow the latest batch: the ones the viewer may
// see (theirs, or their team's), less any whose cancel is waiting for Undo. Their times
// read in the zone the user schedules in and say the year only when it isn't
// this one, so they also follow the current day.
const selectScheduledFeed = _toolkit.createSelector.call(void 0, 
  [
    selectScheduledRows, _scheduledMessages.selectHiddenScheduledMessages, _scheduledMessages.selectScheduledViewer, selectChatType, _scheduledMessages.selectScheduleTimeZone,
    selectCurrentDay,
  ],
  (rows, hidden, viewer, chatType, timeZone) => _conversation.processScheduledMessages.call(void 0, 
    rows.filter(row => !hidden[row.ScheduledMessageKey]), new Date(), viewer, chatType, timeZone,
  ),
  MAX_TEN,
)

const selectChatBatches = _toolkit.createSelector.call(void 0, 
  [
    selectConversation,
    selectBlobject,
    selectMessages,
    _user.selectCurrentUserKey,
    selectLastSeenTime,
    selectConversationKey,
    selectBlobjectKey,
    selectHighlightedMessageKey,
    selectCurrentDay,
  ],
  (
    conversation,
    blobject,
    // Rows in the messages slice; failed optimistic rows carry
    // hasFailedPreviously (see messageReducer's StoreMessage).
    storeMessages,
    currentUserKey,
    lastSeenTime,
    _conversationKey,
    _blobjectKey,
    highlightedMessageKey,
    // selectCurrentDay's value is not read: it only triggers the recompute,
    // and processMessages reads the clock itself.
  ) => {
    const latestMessage = storeMessages[storeMessages.length - 1]
    const hasLatestMessage = conversation && latestMessage &&
      conversation.MessageSequence <= latestMessage.Sequence

    if (!storeMessages.length || !blobject || !hasLatestMessage) {
      return EMPTY_CHAT
    }

    const lastSeenMessage = _lodash.findLast.call(void 0, 
      storeMessages,
      m => m.UserKey === currentUserKey || !_time.isAfter.call(void 0, m.SentAt, lastSeenTime),
    ) || storeMessages[0] // non-empty: checked above

    const lastSeenMessageKey = lastSeenMessage.MessageKey
    const lastSeenMessageSequence = lastSeenMessage.Sequence
    const totalMessagesCount = conversation.MessageSequence
    const unreadMessagesCount = Math.max(
      totalMessagesCount - lastSeenMessageSequence,
      0,
    )

    const relevantMessageKey = highlightedMessageKey || lastSeenMessageKey
    const relevantMessage = _lodash.findLast.call(void 0, 
      storeMessages,
      m => m.MessageKey === relevantMessageKey,
    )

    if (!relevantMessage) return EMPTY_CHAT

    const { relevantBatchIdx, batches: rawBatches } = storeMessages.reduce(
      (acc, m, i, msgs) => {
        const prevMsg =
          msgs[i - 1] || { Sequence: m.Sequence - 1 }

        if (
          m.Sequence !== prevMsg.Sequence + 1 &&
          !m.hasFailedPreviously &&
          !prevMsg.hasFailedPreviously
        ) acc.batches.push([])

        const currentBatchIdx = acc.batches.length - 1
        if (m.MessageKey === relevantMessageKey) {
          acc.relevantBatchIdx = currentBatchIdx
        }

        acc.batches[currentBatchIdx].push(m)
        return acc
      },
      { relevantBatchIdx: 0, batches: [[]] },
    )

    const messageBatches = _conversation.processMessageBatches.call(void 0, rawBatches, conversation, blobject)
    const latestBatchIdx = messageBatches.length - 1
    // An image inside a group, and a caption, are drawn by another row;
    // landing on the message lands on that row.
    const relevantMessageIdx = messageBatches[relevantBatchIdx]
      .findIndex(m => _conversation.rowShowsMessage.call(void 0, m, relevantMessageKey))

    return {
      messageBatches,
      relevantMessageKey,
      relevantBatchIdx,
      relevantMessageIdx,
      latestBatchIdx,
      unreadMessagesCount,
      totalMessagesCount,
      currentUserKey,
      lastSeenTime,
      lastSeenMessageKey,
      lastSeenMessageSequence,
    }
  },
  MAX_TEN,
)

 const selectChatBoxState = _toolkit.createSelector.call(void 0, 
  [
    selectChatBatches,
    _user.selectIsCurrentUserActive,
    selectSubscribers,
    selectConversationKey,
    selectScheduledFeed,
  ],
  (chatBatches, isCurrentUserActive, subscribers, conversationKey, scheduledFeed) => {
    if (chatBatches === EMPTY_CHAT) return EMPTY_CHAT

    return {
      isCurrentUserActive,
      ...chatBatches,
      conversationKey,
      subscribers,
      scheduledFeed,
    }
  },
  MAX_TEN,
); exports.selectChatBoxState = selectChatBoxState

// The (state, props) adapter mobile's MessagesBox calls; web's
// StoreConversationBox uses selectChatBoxState directly.
const mapChatBoxState = (state, props) =>
  exports.selectChatBoxState.call(void 0, state, props)

exports. default = mapChatBoxState
